module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createFromSubject":"Create from existing subject"},"fr":{"createFromSubject":"Créer à partir d\u0027un sujet existant"}}')
  delete Component.options._Ctor
}
